import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import { NavLink } from 'react-router-dom';

const Ingredient = (props) => {
  let redStyle = {
    'borderColor': 'red',
    'maxWidth': '90px'
  }
  let normalStyle = {
    'borderColor': 'rgb(233, 235, 236)',
    'maxWidth': '90px'
  }
  return(
    <tr>
      <td className="hidden-xs-down">
        <span className="badge badge-pill badge-success">SCAN</span>
      </td>
      <td className="hidden-xxs-down">
        <NavLink to={`/inventory/${props.ingredient.inventory_id}/`}>{props.ingredient.inventory_id}</NavLink>
      </td>
      <td>{props.ingredient.item.name}</td>
      {(!props.ingredient.item.allows_leftovers) ?
        <td className="d-flex">
            <input type="number"
              className="form-control"
              value={props.ingredient.amount}
              onChange={(amount) => props.onIngredientAmountChange(amount, props.index)}
              tabIndex="1"
              disabled={props.ingredient.disableChange}
              onBlur={() => props.onBlur(props.index)}
              style={(props.index in props.changeAmountError || props.ingredient.amount===0)? redStyle : normalStyle} />
            <div className="measureUnit ml-05">
              <span className="badge badge-pill badge-info">{props.ingredient.item.measure_unit? props.ingredient.item.measure_unit : 'kg'}</span>
            </div>
        </td>
        :
        <td>
          <span>{props.ingredient.weight}</span>
          <span className="badge badge-pill badge-info ml-05">{props.ingredient.item.measure_unit? props.ingredient.item.measure_unit : 'kg'}</span>
        </td>
      }
      <td>
        <button className="btn btn-danger btn-sm" disabled={props.disableDelete || props.ingredient.disableChange || props.isLoading} onClick={() => props.onIngredientDelete(props.index)}><i className="fa fa-trash"></i></button>
      </td>
    </tr>
  )
}

export default class ListIngredients extends Component {

  constructor(props) {
    super(props);
    this.state = { isOpened: true }
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse(){
    this.setState({isOpened: !this.state.isOpened});
  }

  render(){
    return(
      <div className="card">
        <div className="d-flex justify-content-between align-items-center card-header pointer" onClick={this.toggleCollapse}>
          <div className="d-flex">
            <h5 className="mr-05 mb-0">{this.props.title}</h5>
            {this.state.isOpened ? null : <span>{' (' + this.props.ingredients.length + ')'} </span> }
          </div>
          <i className={`fa ${this.state.isOpened ? "fa-caret-up" : "fa-caret-down"}`}></i>
        </div>
        <Collapse isOpened={this.state.isOpened}>
          <div className="card-block p-0 m-0">
            {this.props.ingredients.length ?
              <table className="table table-striped table-hover mb-0">
                <thead>
                  <tr>
                    <th className="hidden-xs-down">Type</th>
                    <th className="hidden-xs-down">Inventory ID</th><th className="hidden-sm-up hidden-xxs-down">ID</th>
                    <th>Item</th>
                    <th className="hidden-xs-down">Qty Taken</th><th className="hidden-sm-up">Taken</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.ingredients.map((ingredient,index)=>{
                    return(
                      <Ingredient
                        ingredient={ingredient}
                        onIngredientAmountChange={this.props.onIngredientAmountChange}
                        onBlur={this.props.onBlur}
                        changeAmountError={this.props.changeAmountError}
                        onIngredientDelete={this.props.onIngredientDelete}
                        disableDelete={this.props.intermediateLabels}
                        index={index}
                        key={index}
                        isLoading={this.props.isLoading}
                      />
                    )
                  })}
                </tbody>
              </table>
            :
              <div className="empty-table"><span>No ingredients yet</span></div>
            }
          </div>
        </Collapse>
      </div>
    )
  }
}
